import * as _ from 'lodash'
import lang from 'lang'
import config from 'config'

export default _.assign({}, config, {
  saveLetterPaperUrl: `${config.resourceHost}setting/letterPaper`,
  saveLetterPaperImageUrl: `${config.resourceHost}setting/letterPaper/image`,

  fineUploader: {
    messages: {
      minWidthImageError: lang.logoUploadMinWidthError,
      maxWidthImageError: lang.logoUploadMaxWidthError,
      minHeightImageError: lang.logoUploadMinHeightError,
      maxHeightImageError: lang.logoUploadMaxHeightError,
      minSizeError: lang.logoUploadMinSizeError,
      sizeError: lang.logoUploadMaxSizeError,
      typeError: lang.logoUploadFileTypeError,
    },
    validation: {
      acceptFiles: ['image/jpg', 'image/jpeg', 'image/png', 'image/svg+xml'],
      allowedExtensions: ['jpg', 'jpeg', 'png', 'svg'],
      sizeLimit: 10 * 1024 * 1024, // 10 mb
    },
    scaling: {
      sendOriginal: false,
      sizes: [
        { name: 'default', maxSize: 2250 },
      ],
    },
  },

  // Letter Elements & Fabric Configuration
  fabricOptions: {
    cornerColor: '#5a9ff5',
    hasRotatingPoint: false,
    lockScalingFlip: true,
    lockUniScaling: true,
    minScaleLimit: 0.25,
    padding: 10,
    strokeWidth: 0,
    transparentCorners: false,
  },

  fabricShapeOptions: {
    cornerColor: '#5a9ff5',
    hasRotatingPoint: false,
    lockScalingFlip: true,
    padding: 10,
    strokeWidth: 0,
    transparentCorners: false,
  },

  fonts: [
    {
      name: 'Fira Sans',
      default: true,
      selected: true,
      regular: 400,
      bold: 700,
      italic: true,
    },
    {
      name: 'Source Sans Pro',
      regular: 400,
      bold: 700,
      italic: true,
    },
    { name: 'Caveat', regular: 400, bold: 700, italic: false },
    { name: 'Dancing Script', regular: 400, bold: 700, italic: false },
    { name: 'Economica', regular: 400, bold: 700, italic: false },
    { name: 'Gruppo', regular: 400, bold: false, italic: false },
    { name: 'Kalam', regular: 400, bold: 700, italic: false },
    { name: 'Merriweather Sans', regular: 400, bold: 700, italic: false },
    { name: 'Open Sans Condensed', regular: 300, bold: 700, italic: false },
    { name: 'PT Sans Narrow', regular: 400, bold: 700, italic: false },
    { name: 'Shadows Into Light', regular: 400, bold: false, italic: false },
    { name: 'Source Serif Pro', regular: 400, bold: 700, italic: true },
    { name: 'Tulpen One', regular: 400, bold: false, italic: false },
    { name: 'Voltaire', regular: 400, bold: false, italic: false },
  ],
})
